// Module
var code = "<div class=\"btpg-share\" ng-if=\"$ctrl.stepId && $ctrl.platformLabel\"> <support-share item-url=\"$ctrl.wtuItemUrl\" pdf-url=\"$ctrl.btpgPdfUrl\"> </support-share> </div>";
// Exports
module.exports = code;